import Screen from './screen';
import template from './templates/waiting.html';
import WaitingTimeDrawer from '../../utils/waitingTimeDrawer';
import { resizeContentHeight } from '../../utils/resizeContentHeight';
export class WaitingScreen extends Screen {
    constructor(uic) {
        super("waiting", uic);
        /**
         * Switches to the waiting screen by showing a animation-
         *
         * @param wait number of seconds to wait until waiting screen is shown
         */
        this.switchToWaitingScreen = (wait) => {
            this.uic.widget.getStateMachine().screen = this.name;
            this.uic.chatScreen.loadingAnimation();
            setTimeout(() => {
                this.uic.showScreen(this.name);
            }, wait * 1000);
        };
        this.resizeContent = () => {
            resizeContentHeight(this.elements['widgetWindow'], this.elements['content']);
        };
        this.elements = {};
    }
    show(options) {
        if (this.uic.widget.activeChatSession()) {
            if (!this.uic.widget.cachingService.state.botWasConnected) {
                this.uic.hideDownloadIcon();
            }
            if (this.uic.configuration.enableWaitingBanner && this.uic.widget.getStateMachine().botWasConnected && this.uic.widget.getStateMachine().mode != 'autoOpen') {
                if (!this.uic.widget.getStateMachine().tracked.waitingTeaserView) {
                    this.uic.widget.getStateMachine().tracked.waitingTeaserView = true;
                    this.uic.widget.track("chat", "view", "waiting_screen_teaser");
                }
                this.elements['waitingBanner'].show();
            }
            else {
                this.elements['waitingBanner'].hide();
            }
            this.uic.setOnboarding(this.name);
            if (!this.uic.configuration.disableWaitingTime) {
                this.uic.widget.getWaitingTime().then((waitingTime) => {
                    this.elements['waitingTimeInMinutes'].show();
                    this.elements['waitingTimeText'].show();
                    this.elements['progressbarContainer'].show();
                    this.elements['waitingTimeInMinutes'].html(this.waitingTimeDrawer.getDrawer(waitingTime));
                    this.showProgress(waitingTime);
                });
            }
            else {
                this.elements['waitingTimeInMinutes'].hide();
                this.elements['waitingTimeText'].hide();
                this.elements['progressbarContainer'].hide();
            }
            this.elements['waiting'].show();
        }
        else {
            this.uic.showScreen("chat");
        }
    }
    hide() {
        this.elements['waiting'].hide();
        this.uic.chatScreen.stopLoadingAnimation();
        if (!!this.elements['progressbar']) {
            const $element = this.elements['progressbar'];
            $element.stop();
        }
    }
    /**
   * Initializes and starts progress bar
   * @param waitingTime in seconds
   */
    showProgress(waitingTime) {
        if (waitingTime < 0) {
            waitingTime = 600;
        }
        let self = this;
        const durationInMs = waitingTime * 1000;
        const $element = self.elements['progressbar'];
        var last = 0.0;
        var total = 0.0;
        var start = 0.0;
        var delta = 0.0;
        var y = 0.0;
        // offset so that the progessbar takes infinite time to finish
        var offset = -0.00000000000023016719 * Math.pow(durationInMs, 3) + 0.00000085725478203005 * Math.pow(durationInMs, 2) + 2.48975440347976473277 * durationInMs - 17357.20554114878177642822;
        if (durationInMs < 30000) {
            offset = 0.00000000008432432430 * Math.pow(durationInMs, 3) + 0.00000731565191341987 * Math.pow(durationInMs, 2) + 1.67369973273252981016 * durationInMs - 1672.26611194387078285217;
        }
        function progress() {
            $element.css({
                'width': `${100 - (total * 100 / durationInMs)}%` // custom property: start value 
            }).prop({ 'val': 0 })
                .animate({
                'val': 5000
            }, {
                'duration': 5000,
                'easing': 'linear',
                'step': function (now, tween) {
                    if (tween.prop === 'val') {
                        var now_new = start + now;
                        delta = now_new - last;
                        // formula was created by trail and error and some math :)
                        // progress will be smaller the closer it comes to the end
                        // sigmoid curve: https://en.wikipedia.org/wiki/Logistic_function
                        y = (1 - (1 / (1 + Math.exp(-(3 / durationInMs) * (now_new + offset)) * ((durationInMs / 5) - 1))));
                        last = now_new;
                        total = total + delta * y;
                        $element.css({ 'width': `${100 - (total * 100 / durationInMs)}%` });
                    }
                },
                'complete': function () {
                    if (total < durationInMs) {
                        start = last;
                        progress();
                    }
                }
            });
        }
        progress();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.elements['widgetWindow'] = $('#chatbotWindow');
        this.elements['waiting'] = $('#cbot-waiting-chatwindow');
        this.elements['content'] = $('#cbot-waiting-chatwindow .cbot-screen__content');
        this.elements['waitingTimeInMinutes'] = $('.cbot-handover__time-number');
        this.elements['waitingTimeText'] = $('.cbot-handover__time-text');
        this.elements['progressbarContainer'] = $('#cbot-loadingContainer');
        this.elements['handoverParagraph'] = $('#cbot-handoverParagraph');
        this.elements['progressbar'] = $('#cbot-loadingBar');
        this.elements['main_input'] = $('#cbot-chatbotWindowInput');
        this.elements['waitingBanner'] = $('#cbot-handover-banner');
        this.elements['waitingBannerButton'] = $('#cbot-handover-banner-button');
        if (this.uic.configuration.links && this.uic.configuration.links.waitingBannerButtonLink) {
            this.elements['waitingBannerButton'].attr('href', this.uic.configuration.links.waitingBannerButtonLink);
        }
        this.elements['waitingBannerButton'].on('click', $.proxy(function (e) {
            this.uic.widget.track("chat", "click", "waiting_screen_teaser");
        }, this));
        // --------
        this.elements['waitingBanner'].hide();
        this.waitingTimeDrawer = new WaitingTimeDrawer();
    }
    resizeEvent() {
        this.resizeContent();
    }
}
